module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "expertsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=expertsView!./src/pages/Shop/Product/FreeShipping/index.js
// module id = 1400
// module chunks = 418